import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  find,
} from 'lodash';
import {
  Field2 as Field,
} from 'vibeguide';
import {
  Grid,
} from '@mui/material';

class Information extends PureComponent {
  constructor(props) {
    super(props);

    const {
      user,
    } = props;

    const canMessageUpload = user.can('message.upload');
    const canAdvertisementRequest = user.can('advertisement.request');

    const messageTypeOptions = [
      {
        value: '',
        label: '',
      },
      {
        value: 'std',
        label: 'Regular',
      },
    ];

    if (canMessageUpload) {
      // Allow the user to upload a regular message
      messageTypeOptions.push({
        value: 'ext',
        label: 'Regular (Upload)',
      });
    }

    if (user.isAdminCompany) {
      if (canAdvertisementRequest) {
        // Allow user to create an Advertisement
        messageTypeOptions.push({
          value: 'ad',
          label: 'Ad',
        });
      }

      if (canAdvertisementRequest && canMessageUpload) {
        // Allow user to upload an Advertisement
        messageTypeOptions.push({
          value: 'ext-ad',
          label: 'Ad (Upload)',
        });
      }

      // Allow user to create an Air Check
      messageTypeOptions.push({
        value: 'air',
        label: 'Air Check',
      });

      // Allow user to create an Spec Check
      messageTypeOptions.push({
        value: 'spec',
        label: 'Spec Spot',
      });
    }

    this.state = {
      messageTypeOptions,
      tag: '',
    };
  }

  /**
   * When a field is changed
   */
  onChange = (e) => {
    const {
      target: {
        name,
        value,
      },
    } = e;

    const {
      onUpdate,
    } = this.props;

    onUpdate({
      [name]: value,
    });
  };

  /**
   * When the message type field is changed
   */
  onChangeType = (e) => {
    const {
      target: {
        name,
        value,
      },
    } = e;

    const {
      type,
      companyId,
      onUpdate,
    } = this.props;

    const {
      ADMIN_COMPANY_ID: adminCompanyId,
    } = process.env;

    const data = {
      [name]: value,
      advertiserId: '',
      advertiserName: '',
    };

    if (value === 'std') {
      // standard message request,
      data.publishMode = 'review';
    }

    if (value === 'ext' || value === 'ad' || value === 'air' || value === 'spec') {
      // Ads, Air Checks and Spec Spots are published automatically by default
      data.publishMode = 'automatic';
    } else if (value === 'ext-ad') {
      // External Ad (uploaded) requires approval and an approver
      data.publishMode = 'approve';
      data.locations = [{
        companyId,
        locationId: '*',
      }];
      data.locationsData = {
        companies: [{
          _id: companyId,
          locations: [],
          locationCount: '*',
        }],
        locations: [],
      };

      // reset any message block selections
      data.messageLists = [];
      data.messageBlocks = [];
    }

    if (value === 'ad' || value === 'air' || value === 'spec') {
      // Force company to admin company
      data.companyId = adminCompanyId;
      data.companyName = 'Vibenomics, Inc.';
    }

    if (value === 'air' || value === 'spec') {
      data.startDate = '';
      data.endDate = '';
      data.locations = [{
        companyId: adminCompanyId,
        locationId: '*',
      }];
      data.locationsData = { companies: [], locations: [] };
      data.messageLists = [];
      data.messageBlocks = [];
    } else if (type === 'air' || type === 'spec') {
      // switching from air or spec to not air or spec, clear locations
      data.locations = [];
      data.locationsData = { companies: [], locations: [] };
    }

    if (value !== 'ad' || value !== 'ext-ad') {
      // If the previous type was ad, hide the selector
      // Remove the advertiser if one was selected
      data.advertiserId = '';
      data.advertiserName = '';
    }

    data.file = undefined;

    onUpdate(data);
  };

  /**
   * When the tag field is changed
   */
  onChangeTag = (e) => {
    const {
      target: {
        value,
      },
    } = e;

    this.setState({
      tag: value,
    });
  };

  /**
   * When the company field is changed
   */
  onSetCompany = ({
    id: companyId,
    value: companyName,
  }) => {
    const {
      type,
      companyId: currCompanyId,
      tags,
      onUpdate,
    } = this.props;

    const data = !companyId
      ? {
        allLocations: false,
        locations: [],
        locationsData: {
          companies: [],
          locations: [],
        },
        tags: currCompanyId !== companyId
          ? tags.filter(tag => tag.type === 'admin')
          : tags,
      }
      : {};

    // force ACAF locations if an external ad request
    if (type === 'ext-ad') {
      data.locations = [{
        companyId,
        locationId: '*',
      }];

      data.locationsData = {
        companies: [{
          _id: companyId,
          name: companyName,
          locations: [],
          locationCount: '*',
        }],
        locations: [],
      };
    }

    onUpdate({
      companyId,
      companyName,
      // reset the approver when the company changes
      approverId: '',
      approverFname: '',
      approverLname: '',
      ...data,
    });
  };

  /**
   * When the advertiser field is changed
   */
  onSetAdvertiser = ({
    advertiserId,
    advertiserName,
  }) => {
    const {
      onUpdate,
    } = this.props;

    onUpdate({
      advertiserId,
      advertiserName,
    });
  };

  onAddTag = (tag) => {
    const {
      tags,
      onUpdate,
    } = this.props;

    const existingTag = find(tags, { _id: tag._id });

    // Tag is already added (and not queued for removal)
    if (existingTag && existingTag.status !== 'remove') {
      return;
    }

    onUpdate({
      tags: [
        ...tags,
        {
          ...tag,
          status: 'add',
        },
      ],
    });
  };

  onRemoveTag = (tag) => {
    const {
      tags,
      onUpdate,
    } = this.props;

    const existingTag = find(tags, { _id: tag._id });

    // Tag exists, add a remove status
    if (existingTag && existingTag.initialTag) {
      onUpdate({
        tags: tags.map((t) => {
          if (t._id === existingTag._id) {
            return {
              ...t,
              ...tag,
            };
          }

          return t;
        }),
      });
    } else {
      // Remove the tag
      onUpdate({
        tags: tags.map((t) => {
          if (t._id === tag._id) {
            return {
              ...t,
              status: 'remove',
            };
          }

          return t;
        }),
      });
    }
  };

  render() {
    const {
      user,
      name,
      type,
      companyId,
      companyName,
      advertiserId,
      advertiserName,
      tags,
      voiceTalentId,
      disableInput,
      isNew,
    } = this.props;

    const {
      messageTypeOptions,
      tag,
    } = this.state;

    const isVoiceTalent = user.voiceTalent && user._id === voiceTalentId;
    const canSetCompany = user.sysAdmin;
    const showCompany = canSetCompany || isVoiceTalent;
    const showAdSelector = (type === 'ad' || type === 'ext-ad') && user.can('advertiser.view');

    return (
      <div className="Information">
        <Grid
          className="row"
          spacing={2}
          container
        >
          <Grid
            className="details-title"
            xs={6}
            item
          >
            Information
          </Grid>
        </Grid>

        <Grid
          className="row"
          spacing={2}
          container
        >
          <Grid
            xs={showCompany
              ? 6
              : 12}
            item
          >
            <Field
              type="text"
              label="Message Request Name"
              name="name"
              placeholder="Message Request Name"
              value={name}
              tabIndex={1}
              disabled={disableInput}
              onChange={this.onChange}
              required
              autoFocus
            />
          </Grid>

          {showCompany && (
            <Grid xs={6} item>
              <Field
                type="company"
                label="Company"
                name="companyName"
                value={companyName}
                tabIndex={2}
                companyProps={{
                  companyId,
                  companyName,
                }}
                disabled={type === 'ad' || type === 'air' || type === 'spec' || !isNew}
                onChange={this.onSetCompany}
                required
              />
            </Grid>
          )}
        </Grid>

        {!isVoiceTalent && (
          <Grid
            className="row"
            spacing={2}
            container
          >
            <Grid xs={6} item>
              <Field
                type={messageTypeOptions.length > 1
                  ? 'select'
                  : 'hidden'}
                label="Type"
                name="messageType"
                value={type}
                tabIndex={3}
                options={messageTypeOptions}
                disabled={disableInput || !companyId || !isNew}
                onChange={this.onChangeType}
                required
              />
            </Grid>

            {showAdSelector && (
              <Grid xs={6} item>
                <Field
                  type="advertiser"
                  label="Advertiser"
                  value={advertiserName}
                  tabIndex={4}
                  advertiserProps={{
                    advertiserId,
                    advertiserName,
                    setAdvertiser: this.onSetAdvertiser,
                  }}
                  disabled={disableInput || !isNew}
                  required
                />
              </Grid>
            )}

            <Grid xs={12} item>
              <Field
                type="tags"
                label="Tags"
                value={tag}
                tagProps={{
                  assign: user.can('message.assign_tag'),
                  companyId,
                  tags,
                  onAdd: this.onAddTag,
                  onRemove: this.onRemoveTag,
                }}
                tabIndex={5}
                disabled={disableInput}
                onChange={this.onChangeTag}
              />
            </Grid>
          </Grid>
        )}
      </div>
    );
  }
}

Information.propTypes = {
  name: PropTypes.string,
  type: PropTypes.string,
  companyId: PropTypes.string,
  companyName: PropTypes.string,
  advertiserId: PropTypes.string,
  advertiserName: PropTypes.string,
  tags: PropTypes.arrayOf(PropTypes.object),
  voiceTalentId: PropTypes.string,
  disableInput: PropTypes.bool,
  isNew: PropTypes.bool,
  onUpdate: PropTypes.func,
};

Information.defaultProps = {
  name: '',
  type: 'std',
  companyId: '',
  companyName: '',
  advertiserId: '',
  advertiserName: '',
  tags: {},
  voiceTalentId: '',
  disableInput: false,
  isNew: false,
  onUpdate: () => {},
};

function mapStateToProps(state) {
  return {
    user: state.login.user,
  };
}

export default connect(mapStateToProps)(Information);
